export const DASHBOARD = '/'
export const LOGIN = '/login'
export const THEMES = '/themes'
export const THEME_DETAIL = '/themes/:themeId'
export const ADD_THEME = '/theme-new'
export const HOOKS = '/hooks'
export const HOOK_DETAIL = '/hooks/:hookId'
export const ADD_HOOK = '/hook-new'
export const PROFILES = '/profiles'
export const PAYMENT_TEMPLATES = '/payment_templates'
export const STATS = '/stats'
export const USER_CHATS = '/userchats'
